module.exports = __webpack_public_path__ + "static/media/StudentZoleDark.fc0e4b81.png";